import { SVGIcon } from '@superops/super-icons';
import { Link } from '@superops/ui-design-system';
import React from 'react';
import { Row } from './FlexLayout';

export function AddMoreButton({
  onAddMoreClick,
  label,
  className = ''
}: {
  onAddMoreClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  label: React.ReactNode;
  className: string;
}) {
  return (
    <Row
      gap={5}
      onClick={onAddMoreClick}
      className={`items-center cursor-pointer ${className || ''} w-fit`}
    >
      <SVGIcon name="Add" color="#000FF0" />
      <Link removeUnderline>{label}</Link>
    </Row>
  );
}
